"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _DOMAIN = 'app/';
exports.default = {
  INIT: _DOMAIN + 'INIT',
  INIT_FAILURE: _DOMAIN + 'INIT_FAILURE',
  SET_GROUP_SWIPED: _DOMAIN + 'SET_GROUP_SWIPED',
  SET_ITEM_SWIPED: _DOMAIN + 'SET_ITEM_SWIPED',
  SET_FOREGROUND_NOTIFICATION: _DOMAIN + 'SET_FOREGROUND_NOTIFICATION',
  CLEAR_FOREGROUND_NOTIFICATION: _DOMAIN + 'CLEAR_FOREGROUND_NOTIFICATION',
  CLEAR_ERROR_NOTI: _DOMAIN + 'CLEAR_ERROR_NOTI',
  CLEAR_LAST_ERROR: _DOMAIN + 'CLEAR_LAST_ERROR',
  SET_LAST_ERROR: _DOMAIN + 'SET_LAST_ERROR',
  ON_NOTI_GROUP_NEW_PENDING: _DOMAIN + 'ON_NOTI_GROUP_NEW_PENDING',
  ON_NOTI_GROUP_NEW_APPROVED: _DOMAIN + 'ON_NOTI_GROUP_NEW_APPROVED',
  ON_NOTI_ITEM_REVIEWED: _DOMAIN + 'ON_NOTI_ITEM_REVIEWED',
  ON_NOTI_ITEM_APPROVED: _DOMAIN + 'ON_NOTI_ITEM_APPROVED',
  ON_NOTI_ITEM_REJECTED: _DOMAIN + 'ON_NOTI_ITEM_REJECTED'
};